import React, { memo, useState } from "react";
import styled from "styled-components";
import ProductExtra from "./ProductExtra";
import { MdAdd } from "react-icons/md";
import { SubmitButton } from "../InputFields/utils";
import NumberInputField from "../InputFields/NumberInputField";

interface ProductExtrasProps {
  item: any;
  control: any;
  reset: boolean;
  setValue: any;
}

const createNewExtra = (id: number) => {
  return {
    id,
    title: `Екстра ${id}`,
    data: [
      {
        required: true,
        options: undefined,
        type: "image",
        title: "Снимка",
        name: `extras_image_file_${id}`,
      },
      {
        required: true,
        options: undefined,
        type: "text",
        title: "Заглавие",
        name: `extras_title_${id}`,
      },
      {
        required: false,
        options: undefined,
        type: "text",
        title: "Описание",
        name: `extras_description_text_${id}`,
      },
    ],
  };
};

const countField = (n: number) => {
  return {
    required: true,
    options: undefined,
    type: "number",
    title: "Брой екстри",
    name: `extras_count`,
    value: n,
  };
};

const ProductExtras: React.FC<ProductExtrasProps> = ({ item, control, reset, setValue }) => {
  const [options, setOptions] = useState<any[]>(
    item.value && item.value.length !== 0 ? item.value : [] //new Array(createNewExtra(0))
  );

  const [countState, setCountState] = useState(
    item.value && item.value.length !== 0 ? countField(item.value.length - 1) : countField(0)
  );

  const renderFields = (option: any) => {
    return (
      <ProductExtra
        key={option.id}
        id={option.id}
        item={option}
        reset={reset}
        setValue={setValue}
        control={control}
        onDelete={onDelete}
      />
    );
  };

  const onAdd = () => {
    let _options = [...options];
    const newId = _options.length > 0 ? _options[_options.length - 1].id + 1 : 0;
    _options.push(createNewExtra(newId));
    setOptions(_options);
    setValue("extras_count", newId);
  };

  const onDelete = (id?: number) => {
    let _options = [...options];
    const index = _options.findIndex((item) => item.id === id);
    if (index > -1) {
      _options.splice(index, 1);
      setOptions(_options);
    }
  };

  return (
    <ProductExtrasContainer>
      <>{options.map((option: any) => renderFields(option))}</>
      <CountHidden>
        <NumberInputField item={countState} control={control} reset={reset} setValue={setValue} />
      </CountHidden>
      <Buttons>
        <SubmitButton variant="contained" color="primary" startIcon={<MdAdd size="1.5rem" />} onClick={onAdd}>
          Добави
        </SubmitButton>
      </Buttons>
    </ProductExtrasContainer>
  );
};

const ProductExtrasContainer = styled.div``;
const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;

const CountHidden = styled.div`
  display: none;
`;
export default memo(ProductExtras);
